module.exports = __webpack_public_path__ + "media/audio22.242836f1.mp3";